import http from '../../services/httpService'

const api = {
  apiUrl: `${process.env.VUE_APP_YOUVENDO_API_SERVER}/api/v1`,
  /* Should be dropped */
  getStarCatalogue: function (params) {
    return http.get(`/skysources/catalogue/all`, { params })
  }
}

export default api
